<template>
  <div id="root">
    <el-row type="flex" class="row-bg">
      <el-col>
        <div class="grid-content bg-purple">
          <h1>{{ title }}</h1>
        </div>
      </el-col>
    </el-row><el-row>
      <el-col>
        <h3 v-if="error">
          <!-- {{ error }} -->
          An error ocurred. Try reloading the page or confirming that you were added to Discipleship by a staff member.
        </h3>
        <div class="grid-content" style="margin-bottom: 10px;" v-if="!error">
          <el-button type="primary" @click.native="modals.addDisciple = true">
            Add Disciple <i class="el-icon-plus el-icon--right" />
          </el-button>
          <el-button type="danger" @click.native="modals.removeDisciple = true">
            Remove Disciple <i class="el-icon-minus el-icon--right" />
          </el-button>
          <el-button
            v-if="isOneOfTheseRoles(['missionary', 'affiliate', 'chaplain', 'td',
                                     'superadmin', 'parish-missionary', 'parish-td'])"
            class="transfer-button"
            @click.native="modals.transferDisciple = true"
          >
            Transfer Disciple <i class="el-icon-arrow-right el-icon--right" />
          </el-button>
          <br>
          <el-button type="default" class="growing-button" @click.native="modals.changeGrowing = true">
            Mark Disciples as
            <span class="growing-disciple">Growing</span> or
            <span class="commissioned-disciple">Commissioned</span>
          </el-button>
          <el-tooltip
            content="Growing Disciples show time since becoming a growing disciple.
            Commissioned disciples, disciple makers, and spiritual multipliers show time since becoming commissioned."
            :open-delay="300"
            placement="top"
            v-if="isOneOfTheseRoles(['rd', 'ad', 'td', 'pd', 'admin'])"
          >
            <el-button
              type="default"
              class="growing-button"
              id="days-in-dship"
              @click="toggleShowTimeInDship()"
            >
              <span v-show="!showTimeInDiscipleship">Show Time in Discipleship</span>
              <span v-show="showTimeInDiscipleship">Hide Time in Discipleship</span>
            </el-button>
          </el-tooltip>
          <el-select
            class="select-default col-md-2"
            filterable
            v-if="isOneOfTheseRoles(['regional'])"
            clearable
            style="margin:10px;"
            v-model="locationId"
            placeholder="Select location..."
          >
            <el-option
              v-for="item in locations"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          <div
            class="card col-md-3"
            style="float:right; padding:20px;"
            v-if="isOneOfTheseRoles(['missionary', 'td', 'rd', 'ad'])
              && !noOrphans"
          >
            <h4 style="margin-top: 5px;text-align:center;">
              Orphan List
              <el-tooltip
                :open-delay="300"
                placement="top"
              >
                <div slot="content">
                  The number beside the orphan's name is <br />
                  the number of disciples in their downchain.
                </div>
                <el-button class="fake-button">
                  <i class="el-icon-info" />
                </el-button>
              </el-tooltip>
            </h4>
            <ul>
              <li v-for="orphan in orphansList" :key="orphan.id">
                {{ orphan.person }} <span v-show="orphan.downchain_count">({{ orphan.downchain_count }})</span>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
    </el-row>

    <div style="display:none;">
      <discipleship-tree
        v-if="isReady"
        :disciples="discipleTree"
      />
    </div>

    <div id="loading" v-if="(isReady == false) && (!error)">
      <h5>
        Loading...
      </h5>
    </div>

    <div id="mobile" class="card" v-if="!error">
      <mobile-tree :tree="this.discipleTreeMobile" />
    </div>

    <add-new-disciple-modal
      :show="modals.addDisciple"
      @close="modals.addDisciple = false"
      @save="updateTrees"
    />
    <transfer-disciple-modal
      :show="modals.transferDisciple"
      @close="modals.transferDisciple = false"
      @save="updateTrees"
    />
    <remove-disciple-modal
      :show="modals.removeDisciple"
      @close="modals.removeDisciple = false"
      @save="updateTrees"
    />
    <change-growing-modal
      :show="modals.changeGrowing"
      @close="modals.changeGrowing = false"
      @save="updateTrees"
    />
  </div>
</template>

<script>
import {
    mapState, mapGetters
} from 'vuex';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

import MobileTree from '../../components/Discipleship/MobileTree';
import AddDiscipleModal from '../../components/Discipleship/AddDiscipleModal';
import TransferDiscipleModal from '../../components/Discipleship/TransferDiscipleModal';
import RemoveDiscipleModal from '../../components/Discipleship/RemoveDiscipleModal';
import ChangeGrowingModal from '../../components/Discipleship/ChangeGrowingModal';
import DiscipleshipTree from '../../components/Discipleship/DiscipleshipTree';

const DisciplesRepository = RepositoryFactory.get('disciples');

const data = 'Discipleship';

export default {
    components: {
        [AddDiscipleModal.name]: AddDiscipleModal,
        DiscipleshipTree,
        MobileTree,
        TransferDiscipleModal,
        RemoveDiscipleModal,
        ChangeGrowingModal
    },
    data() {
        return {
            discipleTreeMobile: [],
            discipleTree: [],
            error: '',
            isReady: false,
            title: 'Discipleship',
            namespace: 'Discipleship',
            orphansList: [],
            showTimeInDiscipleship: false,
            modals: {
                addDisciple: false,
                transferDisciple: false,
                removeDisciple: false,
                changeGrowing: false
            },

        };
    },
    computed: {
        noOrphans() {
            if (typeof this.orphansList === 'undefined') {
                return true;
            }
            if (this.orphansList.length === 0) {
                return true;
            }
            if (this.orphansList.length > 0) {
                return false;
            }
            return false;
        },
        ...mapState({
            locations: (state) => state.userLocations,
        }),
        ...mapGetters({
            locationFromStore: 'lastLocation'
        }),
        locationId: {
            get() {
                return this.locationFromStore;
            },
            set(newLocation) {
                this.$store.commit('setLastLocation', newLocation);
                this.updateTrees();
            }
        }
    },
    methods: {
        toggleShowTimeInDship() {
            this.showTimeInDiscipleship = !this.showTimeInDiscipleship;
            if (this.showTimeInDiscipleship === true) {
                document.querySelectorAll('.timeInDship').forEach((item) => {
                    item.classList.add('show');
                    item.classList.remove('hide');
                });
            } else {
                document.querySelectorAll('.timeInDship').forEach((item) => {
                    item.classList.add('hide');
                    item.classList.remove('show');
                });
            }
        },
        getDiscipleTree() {
            DisciplesRepository.getDiscipleTree(this.locationId)
                .then((response) => {
                    this.discipleTree = response.data.data;
                    this.orphansList = response.data.orphans;

                    // create a div for each tree
                    for (let i = 0; i < this.discipleTree.length; i += 1) {
                        const div = document.createElement('div');
                        div.id = this.discipleTree[i].id;
                        div.className = 'tree';
                        document.getElementById('root').appendChild(div);
                    }
                    // hide all trees. they will be shown in discipleshipTree component
                    const elements = document.getElementsByClassName('tree');
                    for (let i = 0; i < elements.length; i += 1) {
                        elements[i].style.display = 'none';
                    }
                    this.isReady = true;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        },
        getMobileDiscipleTree() { // TODO add this to the above call for efficiency
            DisciplesRepository.getDiscipleTreeMobile(this.locationId)
                .then((response) => {
                    // console.log('mobiletree');
                    // console.log(response.data);
                    this.discipleTreeMobile = response.data;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        },
        updateTrees() {
            this.getDiscipleTree();
            this.getMobileDiscipleTree();
            this.showTimeInDiscipleship = false;
        },
    },
    created() {
        this.getDiscipleTree();
        this.getMobileDiscipleTree();
    },
    beforeDestroy() {
        // todo destroy the state.
    },

};
</script>

<style>
@media only screen and (max-width: 744px) {
    .tree {
        display: none;
    }
}

@media only screen and (min-width: 744px) {
    #mobile {
        display: none;
    }
}

table {
      border-collapse: inherit;
      border-spacing: 0;

}

.tree {
  padding: 20px;
  overflow: auto;
}

.nodes {
    text-align: center;
    vertical-align: middle;
    cursor: default;
    border-radius: 4px;
    font-size: 14px !important;
    color: #66615b;
    /* color: white; keeping these here for record*/
    /* background: #6cc070 */
    background: white;
    border: solid #66615b50;
    border-width: thin;
}

.disciple-text {
  cursor: pointer;
}

.growing-disciple {
  background-color: #6bd09875;
  padding: 0.25px 3px !important;
}

.commissioned-disciple {
  padding: 0.25px 3px !important;
}

.transfer-button {
  background-color: #51bcda;
  color: #FFF;
}

.growing-button {
  margin-top: 15px;
  margin-bottom: 15px;
}

#days-in-dship {
  font-weight: 700;
  border-color: rgb(255,255,51,.7);
  border-width: 3px;
}

.selected .nodes #mobile #loading {
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
}

#mobile {
  padding-top: 10px;
}

.selected {
    text-align: center;
    vertical-align: middle;
    cursor: default;
    border-radius: 4px;
    font-size: 14px !important;
    color: white;
    background: #5061c2
}

#loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 15%;
  padding: 20px;
}
.fake-button {
  border: none;
  background-color: transparent;
  font-weight: bold;
  color: black;
  padding: 0;
  margin-left: 5px;
}

.hide {
  display: none;
}

.show {
  display: inline;
}

.inactive-slbs {
  color: red;
}
</style>
